import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';
// fetch
import { getCounties as fetchCounties } from 'src/fetch/locations';
// consts
import { requestStatuses } from 'shared/../constants/store';

export const loadCounties = createAsyncThunk(
  'counties/loadCountiesStatus',
  (params, { rejectWithValue }) => fetchCounties(params)
      .then((counties) => ({ counties }))
      .catch((error) => rejectWithValue({ error })),
);

const countiesAdapter = getAdapter();

const countiesSlice = createSlice({
  name: 'counties',
  initialState: countiesAdapter.getInitialState({
    loadingStatus: requestStatuses.INIT,
    error: null,
  }),
  reducers: {
    setCounties: (state, { payload: { counties } }) => {
      countiesAdapter.setAll(state, counties);
    },
  },
  extraReducers: {
    [loadCounties.pending]: (state) => {
      state.error = null;
      state.loadingStatus = requestStatuses.PENDING;
    },
    [loadCounties.fulfilled]: (state, { payload: { counties } }) => {
      state.loadingStatus = requestStatuses.SUCCESS;
      countiesAdapter.setAll(state, counties);
    },
    [loadCounties.rejected]: (state, { payload: { error } }) => {
      state.error = error;
      state.loadingStatus = requestStatuses.FAILED;
    },
  }
});

const selectors = countiesAdapter.getSelectors(({ counties }) => counties);

export const getCounties = (state) => selectors.selectAll(state);

export const getCountiesLoadingState = ({ counties }) => ({ loadingStatus: counties.loadingStatus, error: counties.error }); 

export const {
  setCounties,
} = countiesSlice.actions;

export default countiesSlice.reducer;
